import { useParams } from "react-router-dom";

export class NoParamError extends Error {
  name = "NoParamError";

  constructor(public param: string) {
    super(`Param ${param} is not provided`);
  }
}

export function useParam(param: string): string {
  const params = useParams();
  const value = params[param];

  if (value === undefined) {
    throw new NoParamError(param);
  }

  return value;
}
